
import { useQueryClient } from 'react-query';
import axiosClient from '../../http/axios-client';
import { useItems } from '../atoms/items-hook';
import CollectionKeys from './collection-keys';

export const useThematicPackageTrait = () => {
  const {
    createItem: createThematicPackageTrait,
  } = useItems(CollectionKeys.THEMATIC_PACKAGES_TRAITS);

  const addTraitToThematicPackage = (thematicPackage, trait) => {
    return createThematicPackageTrait({ thematicpackage_id: thematicPackage.id, trait_id: trait.id });
  };

  const queryClient = useQueryClient();
  const removeTraitFromThematicPackage = (thematicPackage, trait) => {
    return Promise.resolve()
      .then(() => {
        return axiosClient.get(`${ CollectionKeys.THEMATIC_PACKAGES_TRAITS }`, {
          params: {
            thematicpackage_id: thematicPackage.id,
            trait_id: trait.id,
          },
        });
      })
      .then((ds) => {
        return ds?.[0].id;
      })
      .then((uid) => {
        return axiosClient.delete(`${ CollectionKeys.THEMATIC_PACKAGES_TRAITS }/${ uid }`);
      })
      .then(() => {
        return queryClient.invalidateQueries([ CollectionKeys.THEMATIC_PACKAGES_TRAITS ]);
      });
  };

  return {
    addTraitToThematicPackage,
    removeTraitFromThematicPackage,
  };
};

